export default __webpack_public_path__ + "d3cf8a126a308a64f844defac203fe6e.png";